import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`eslint-plugin-orbit-components`}</h1>
    <p>{`Collection of ESLint rules to enforce the best usage practices of `}<a parentName="p" {...{
        "href": "https://github.com/kiwicom/orbit-components/"
      }}><inlineCode parentName="a">{`@kiwicom/orbit-components`}</inlineCode></a>{`.`}</p>
    <h2>{`Installation`}</h2>
    <p>{`Assuming you already have ESLint installed, run:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`# npm
npm install eslint-plugin-orbit-components --save-dev

# yarn
yarn add eslint-plugin-orbit-components --dev
`}</code></pre>
    <p>{`Then add it to your ESLint configuration:`}</p>
    <pre><code parentName="pre" {...{}}>{`{
  "plugins": [
    // ...
    "orbit-components"
  ],
  "rules": {
    // ...
    "orbit-components/button-has-title": "error",
    "orbit-components/unnecessary-text": "error",
  }
}
`}</code></pre>
    <p>{`or via extending our recommended config:`}</p>
    <pre><code parentName="pre" {...{}}>{`  {
    "extends": [
      "plugin:orbit-components/recommended",
    ]
  }
`}</code></pre>
    <h2>{`Supported Rules`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/kiwicom/eslint-plugin-orbit-components/blob/master/docs/rules/button-has-title.md"
        }}>{`button-has-title`}</a>{`: Enforces that `}<inlineCode parentName="li">{`Button`}</inlineCode>{` and `}<inlineCode parentName="li">{`ButtonLink`}</inlineCode>{` do have either `}<inlineCode parentName="li">{`children`}</inlineCode>{` or `}<inlineCode parentName="li">{`title`}</inlineCode>{` property.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/kiwicom/eslint-plugin-orbit-components/blob/master/docs/rules/unnecessary-text.md"
        }}>{`unnecessary-text`}</a>{`: Enforces that children of `}<inlineCode parentName="li">{`Button`}</inlineCode>{` or `}<inlineCode parentName="li">{`Heading`}</inlineCode>{` are not wrapped in `}<inlineCode parentName="li">{`Text`}</inlineCode>{` component.`}</li>
    </ul>
    <h2>{`License`}</h2>
    <p>{`MIT`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      